import React, { useState, useEffect } from 'react';
import '../style/base.css';
import '../style/navbar.css';
import '../style/pages.css';
import '../style/responsive.css';
import '../style/sidebar.css';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [activeView, setActiveView] = useState('grid');
  const [postContent, setPostContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    try {
      const response = await fetch('/blog-content/posts.json');
      const data = await response.json();
      
      // Transform the posts data from object to array format
      const postsArray = Object.entries(data.posts).map(([slug, post]) => ({
        title: post.metadata?.title || slugToTitle(slug),
        category: post.metadata?.category || 'Blog',
        date: post.metadata?.date || new Date().toLocaleDateString(),
        image: post.metadata?.image || post.content[0]?.image || '',
        text: post.metadata?.text || post.content[0]?.content || '',
        slug
      }));

      setPosts(postsArray);
      setLoading(false);
    } catch (error) {
      console.error('Error loading posts:', error);
      setLoading(false);
    }
  };

  const slugToTitle = (slug) => {
    return slug
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const handlePostClick = async (post) => {
    setSelectedPost(post);
    setActiveView('detail');
    try {
      const response = await fetch('/blog-content/posts.json');
      const data = await response.json();
      setPostContent(data.posts[post.slug]);
    } catch (error) {
      console.error('Error loading post content:', error);
    }
  };

  if (loading) {
    return (
      <article className="blog active" data-page="blog">
        <header>
          <h2 className="h2 article-title">My Visions</h2>
        </header>
        <p>Loading content...</p>
      </article>
    );
  }

  return (
    <article className="blog active" data-page="blog">
      <header>
        <h2 className="h2 article-title">My Visions</h2>
      </header>

      {activeView === 'grid' ? (
        <section className="blog-posts spacing-10">
          <ul className="blog-posts-list">
            {posts.map((post, index) => (
              <li key={index} className="blog-post-item" onClick={() => handlePostClick(post)}>
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <figure className="blog-banner-box">
                    <img src={post.image} alt={post.title} loading="lazy" />
                  </figure>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <p className="blog-category">{post.category}</p>
                      <span className="dot"></span>
                      <time dateTime={post.date}>{post.date}</time>
                    </div>
                    <h3 className="h3 blog-item-title">{post.title}</h3>
                    <p className="blog-text">{post.text}</p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </section>
      ) : (
        <section className="blog-detail spacing-10">
          <div className="detail-header">
            <button className="back-btn" onClick={() => setActiveView('grid')}>
              <ion-icon name="arrow-back-outline"></ion-icon>
            </button>
            <div className="detail-meta">
              <p className="blog-category">{selectedPost.category}</p>
              <span className="dot"></span>
              <time dateTime={selectedPost.date}>{selectedPost.date}</time>
            </div>
          </div>

          <h3 className="h3 detail-title">{selectedPost.title}</h3>
          
          <figure className="detail-banner">
            <img src={selectedPost.image} alt={selectedPost.title} />
          </figure>

          <div className="detail-content">
            <p className="detail-text">{selectedPost.text}</p>
            <div className="detail-description">
              {postContent ? (
                postContent.content.map((section, index) => (
                  <div key={index} className="content-section">
                    {section.type === 'text' ? (
                      <p>{section.content}</p>
                    ) : section.type === 'section' ? (
                      <>
                        <h3 className="h3">{section.title}</h3>
                        <p>{section.content}</p>
                        {section.image && (
                          <img 
                            className="detail-image" 
                            src={section.image} 
                            alt={section.title} 
                          />
                        )}
                        {section.images && section.images.map((img, i) => (
                          <img 
                            key={i}
                            className="detail-image" 
                            src={img} 
                            alt={`${section.title} ${i + 1}`} 
                          />
                        ))}
                      </>
                    ) : null}
                  </div>
                ))
              ) : (
                <p>Loading content...</p>
              )}
            </div>
          </div>
        </section>
      )}
    </article>
  );
};

export default Blog;
